import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'

import { Icon } from '@independent-software/typeui/controls/Icon';
import { darken } from '@independent-software/typeui/helper/darken';
import { Label } from '@independent-software/typeui/controls/Label';

interface IProps {
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  active?: boolean;
}

const CategoryBase = (props: IProps) => {
  return (
    <div className={props.className}>
      <Label basic={props.active ? null : true} onClick={props.onClick ? props.onClick : null}>
        {props.children}
      </Label>
      <Options>
        {props.onAdd &&
        <Add onClick={props.onAdd}>
          <Icon title="Add subcategory" color="white" name="plus"/>
        </Add>}
        {props.onEdit &&
        <Edit onClick={props.onEdit}>
          <Icon title="Edit category" color="white" name="edit"/>
        </Edit>}     
        {props.onDelete && 
        <Delete onClick={props.onDelete}>
          <Icon title="Delete category" color="white" name="trash"/>
        </Delete>}
      </Options>
    </div>
  )
}

const Options = styled.div`
  display: inline-block;
  overflow-x: hidden;
  white-space: nowrap;
  transition: transform 0.1s ease-in-out;
`

const Add = styled.div`
  cursor: pointer;
  display: inline-block;
  background: ${p => p.theme.primaryColor};
  &:hover {
    background: ${p => darken(p.theme.darken, p.theme.primaryColor)};
  }
  height: 100%;
  padding: 3px 8px 0 8px;
  margin-left: 5px;
`

const Edit = styled.div`
  cursor: pointer;
  display: inline-block;
  background: ${p => p.theme.secondaryColor};
  &:hover {
    background: ${p => darken(p.theme.darken, p.theme.secondaryColor)};
  }
  height: 100%;
  padding: 3px 8px 0 8px;
  margin-left: 5px;
`

const Delete = styled.div`
  cursor: pointer;
  display: inline-block;
  background: ${p => p.theme.negativeColor};
  &:hover {
    background: ${p => darken(p.theme.darken, p.theme.negativeColor)};
  }
  height: 100%;
  padding: 3px 8px 0 8px;
  margin-left: 5px;
`

const Category = styled(CategoryBase)`
  display: inline-flex;
  align-items: flex-start;
  height: 28px;

  ${Options} { 
    transform: scale(0);
  }

  &:hover {
    ${Options} {
      transform: scale(1);
    }
  }
`

export { Category }
